import { Controller, useFormContext } from "react-hook-form";
import {
	Combobox,
	ComboboxLabel,
	ComboboxOption,
} from "@/components/catalyst/Combobox";
import {
	Description,
	ErrorMessage,
	Field,
	FieldGroup,
	Label,
} from "@/components/catalyst/Fieldset";
import { Input } from "@/components/catalyst/Input";
import { Select } from "@/components/catalyst/Select";
import type { CreateReferralLinkFormValues } from "../../schema";

interface Partner {
	id: string;
	name: string;
}

interface BaseSectionProps {
	partners: Partner[];
}

export function BaseSection({ partners }: BaseSectionProps) {
	const {
		register,
		control,
		formState: { errors },
	} = useFormContext<CreateReferralLinkFormValues>();

	return (
		<FieldGroup>
			<div className="grid grid-cols-1 gap-8 mt-4 sm:grid-cols-2">
				<Field>
					<Label>Partner</Label>
					<Controller
						control={control}
						name="partnerId"
						render={({ field: { onChange, value } }) => (
							<Combobox
								options={partners}
								value={partners.find((p) => p.id === value) || null}
								onChange={(partner) => onChange(partner?.id)}
								displayValue={(partner) => partner?.name}
								placeholder="Select a partner"
							>
								{(partner) => (
									<ComboboxOption value={partner}>
										<ComboboxLabel>{partner.name}</ComboboxLabel>
									</ComboboxOption>
								)}
							</Combobox>
						)}
					/>
					{errors.partnerId && (
						<ErrorMessage>{errors.partnerId.message}</ErrorMessage>
					)}
				</Field>

				<Field>
					<Label>Code</Label>
					<Input {...register("slug")} placeholder="e.g. SUMMER-SALE" />
					<Description>
						The code that users will use to claim the offer.
					</Description>
					{errors.slug && <ErrorMessage>{errors.slug.message}</ErrorMessage>}
				</Field>

				<Field>
					<Label>Plan (Optional)</Label>
					<Select {...register("planHint")}>
						<option value="">Any</option>
						<option value="monthly">Monthly</option>
						<option value="yearly">Yearly</option>
					</Select>
				</Field>
			</div>
		</FieldGroup>
	);
}
